import styled from 'styled-components';

export default component => {
  return styled(component)`
    @media only percy {
      visibility: hidden;
    }
  `;
};
